import { BasePageModel, basePageToLocal } from './base';

export interface TestCaseTurn extends BasePageModel {
  query: string;
  structureInput?: string;
  reply?: string;
  stateInfo?: string;
}

export function testCaseTurnToLocal(data: any): TestCaseTurn {
  return {
    query: data.query,
    structureInput: data.structure_input,
    reply: data.reply,
    stateInfo: data.state
  };
}

export function testCaseTurnToServer(data: TestCaseTurn) {
  return {
    query: data.query,
    structure_input: data.structureInput,
    reply: data.reply,
    state: data.stateInfo
  };
}

export interface TestCase {
  id: string;
  name: string;
  turns: TestCaseTurn[];
}

export interface TestCaseRun {
  testCase: TestCase;
  turns: TestCaseTurn[];
  latestRunTime: string;
  result: string;
}

export function testCaseRunToLocal(res: any): TestCaseRun {

  return {
    testCase: res.test_case && {
      id: res.test_case.id,
      name: res.test_case.name,
      turns: res.test_case.turns.map(testCaseTurnToLocal)
    },
    turns: res.turns.map(testCaseTurnToLocal),
    latestRunTime: res.latest_run_time,
    result: res.result
  };
}

export function testCaseToLocal(res: any): TestCase {
  return {
    ...basePageToLocal(res),
    id: res.id,
    name: res.name,
    turns: res.turns.map(testCaseTurnToLocal)
  };
}

export function testCaseToServer(data: TestCase) {
  return {
    id: data.id,
    name: data.name,
    turns: data.turns && data.turns.map(testCaseTurnToServer)
  };
}
